import { FC, PropsWithChildren, useEffect } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { isUserInJail } from "store/apis/jailAPI/jail.helpers"
import { useGetMyJailStatusQuery } from "store/apis/jailAPI/jail.api"
import { ServerDate } from "helpers/server-date.class"

const JailRestrictionGuard: FC<PropsWithChildren> = ({ children }) => {
  const { data: jailStatus, isLoading, refetch } = useGetMyJailStatusQuery()
  const location = useLocation()

  const jailData = jailStatus?.data

  useEffect(() => {
    if (!jailData?.isInJail || !jailData?.timeInfo) {
      return
    }

    const releaseTime = new ServerDate(jailData.timeInfo.releaseDate).getTime()
    const now = new ServerDate().getTime()
    const timeToRelease = releaseTime - now + 3000

    if (timeToRelease <= 0) {
      refetch()
      return
    }

    const timer = setTimeout(() => {
      refetch()
    }, timeToRelease)

    return () => clearTimeout(timer)
  }, [jailData?.timeInfo?.releaseDate, refetch])

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          fontSize: "18px"
        }}
      >
        Loading...
      </div>
    )
  }

  const userIsInJail = isUserInJail(jailData)

  const allowedPathsInJail = ["/jail", "/wallet"]

  const isAllowedPath = allowedPathsInJail.some(
    (path) => location.pathname === path || location.pathname.startsWith(path)
  )

  if (userIsInJail && !isAllowedPath) {
    return <Navigate to="/jail" replace />
  }

  if (!userIsInJail && location.pathname === "/jail") {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default JailRestrictionGuard
